import { render, staticRenderFns } from "./CoverReportTM.vue?vue&type=template&id=685ef735&scoped=true&"
import script from "./CoverReportTM.vue?vue&type=script&lang=js&"
export * from "./CoverReportTM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685ef735",
  null
  
)

export default component.exports